export const SET_MEDIA_ID= 'SET_MEDIA_ID'
export const SET_VIDEO_ID= 'SET_VIDEO_ID'
export const SET_TYPE = 'SET_TYPE'